import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import {
  CardComponent,
  ContractsTable,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  PLAYBOOK_AND_STANDARD__TABLE_COLUMNS,
  PlaybookAndStandardMessages,
} from '../../core-utils/messages/PlaybookAndStandardsConstant';
import axios from 'axios';
import properties from '../../core-utils/properties';
// import { useStores } from '../../stores';
import { useNavigate } from 'react-router-dom';
import { PLAYBOOK_AND_STANDARD_INTERNAL } from '../../core-utils/routes';
import NoPlaybooksData from '../../_components/atoms/Icons/NoPlaybooksData';
import { formatDateToDDMMMMYYYY } from '../../core-utils/helper-utils/helper';
import { useStores } from '../../stores';
import FeatureScreenAccess from '../../_components/organisms/FeatureScreenAccess';
import { isFeatureAccessible } from '../../core-utils/helper-utils/userAccess';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
// import { useStores } from '../../stores';
const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 60px',
    width: '1240px',
  },
  cardTitleContainer: {
    width: '1200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardBody: {
    marginTop: '10px',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    minHeight: '300px',
  },
});

const PlaybookAndStandard = observer(() => {
  const { classes } = useStyles();
  const messages = PlaybookAndStandardMessages;
  const navigate = useNavigate();

  //Stores
  const employerGroupStore = useStores().employerGroupStore;
  const egNid =
    employerGroupStore.employerGroupResponseData.employer_group_name[0];
  const loginPageStore = useStores().loginPageStore;
  const userAccess = loginPageStore.userResponse;
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const combinedScreens = Array.from(
    new Set([
      ...(userAccess.careNavigationScreens || []),
      ...(userAccess.complianceAssuranceScreens || []),
      ...(userAccess.riskManagementScreens || []),
    ]),
  );

  // Your original states (kept exactly)
  const [mainLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredContracts, setFilteredContracts] = useState<any[]>([]);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  // Your original handlers (kept)
  const handleSubRowClick = (row: any, subrow: any) => {
    navigate(PLAYBOOK_AND_STANDARD_INTERNAL, {
      state: {
        contract_id: row?.id,
        redflag_check: subrow.document,
        document_url: subrow.documentUrl,
        service_agreement_name: row.name,
      },
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const RELEVANT_CATEGORIES = [
    'Red Flag Checks',
    'Missing Checks',
    'Key Terms',
  ];

  const transformPlaybooksToRows = (apiItems: any[]) => {
    return apiItems
      .map((item) => {
        const matrixData = item.matrix_data || [];

        // Get categories that exist in matrix_data
        const presentCategories = RELEVANT_CATEGORIES.filter((category) =>
          matrixData.some((m: any) => m.category?.trim() === category),
        );

        if (presentCategories.length === 0) {
          return null;
        }

        return {
          id: item._id,

          name: item.service_agreement_name || 'Unknown Agreement',

          // Number of categories present
          type: presentCategories.length.toString(),

          totalFiles: formatDateToDDMMMMYYYY(item.updatedAt),

          // Create only category-level subrows
          subrows: presentCategories.map((category, index) => ({
            id: `${item._id}-${category}-${index}`,

            document: category,

            documentType: '',

            documentUrl: null,

            parentRow: {
              id: item._id,
              name: item.service_agreement_name,
              type: presentCategories.length.toString(),
              totalFiles: presentCategories.length.toString(),
            },
          })),
        };
      })
      .filter(Boolean);
  };

  const getAllPlayBooks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        properties.aiqBaseUrl +
          properties.playbookAndStandard +
          properties.getAllPlaybooks,
      );
      const result = transformPlaybooksToRows(response?.data?.data || []);

      setFilteredContracts(result);
    } catch (error) {
      handleOpenSnackBar('Task deletion failed.', 'error', 3000);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  useEffect(() => {
    if (!combinedScreens.length) {
      return;
    }

    const hasAccess = isFeatureAccessible(
      'CONTRACT_ANALYSIS',
      combinedScreens,
      userAccess,
    );
    setHasAccess(hasAccess);

    if (!hasAccess) {
      setLoading(false);
      return;
    }

    getAllPlayBooks();
  }, [egNid]);
  const TableAndCardView = () => (
    <ContractsTable
      rowsData={filteredContracts}
      columns={PLAYBOOK_AND_STANDARD__TABLE_COLUMNS}
      showRowMenu={false}
      showSubRowMenu={false}
      handleSubRowClick={handleSubRowClick}
      isRowClickable={false}
    />
  );

  return (
    <Grid container className={classes.root}>
      <FeatureScreenAccess noAccess={hasAccess}>
        {mainLoading ? (
          <Loader />
        ) : (
          <Grid>
            <PageTitleAndSubTitle
              title={
                <Grid
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    flexWrap: 'wrap',
                  }}
                >
                  <Typography
                    fontSize="18px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {messages.MAIN.TITLE}
                  </Typography>
                </Grid>
              }
              subTitle={messages.MAIN.SUBTITLE}
              customButton={false}
              subTitleStyles={{ width: '1240px' }}
            />
            <CardComponent
              title={
                <Grid className={classes.cardTitleContainer}>
                  <Typography
                    fontSize="14px"
                    fontType="semiBold"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {messages.CARD.TITLE}
                  </Typography>
                </Grid>
              }
              body={
                <Grid className={classes.cardBody}>
                  {loading ? (
                    <Loader height="300px" />
                  ) : filteredContracts.length === 0 ? (
                    <div className={classes.noDataContainer}>
                      <NoPlaybooksData />
                      <Typography
                        textColor={patientAccessTheme.palette.text.lowemphasis}
                        fontSize="12px"
                        styleProps={{
                          marginTop: '20px',
                        }}
                      >
                        {messages.NO_DATA.CONTENT}
                      </Typography>
                    </div>
                  ) : (
                    <Grid style={{ marginTop: '24px' }}>
                      <TableAndCardView />
                    </Grid>
                  )}
                </Grid>
              }
              mainGridStyles={{ marginTop: '40px' }}
              subTitle={messages.CARD.SUBTITLE}
            />
          </Grid>
        )}
      </FeatureScreenAccess>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
});

export default PlaybookAndStandard;
